import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { register } from '../../services/api';
import './RegisterPage.css' 

const RegisterPage: React.FC = () => {
  const [email, setEmail] = useState('');          // Обязательное
  const [name, setName] = useState('');            // Обязательное
  const [lastName, setLastName] = useState('');    // Необязательное
  const [birthDate, setBirthDate] = useState('');  // Необязательное
  const [gender, setGender] = useState('');        // Необязательное (будет 'male' или 'female')
  const [password, setPassword] = useState('');    // Обязательное
  const [confirmPassword, setConfirmPassword] = useState(''); // Для валидации
  const [error, setError] = useState('');

  const navigate = useNavigate();

  // Если уже есть токен в localStorage, перенаправляем на главную
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/');
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Валидация обязательных полей
    if (!name || !email || !password || !confirmPassword) {
      setError('Пожалуйста, заполните обязательные поля (Имя, Почта, Пароль, Подтверждение пароля).');
      return;
    }

    // Проверка совпадения паролей
    if (password !== confirmPassword) {
      setError('Пароли не совпадают.');
      return;
    }

    try {
      // Регистрируем пользователя
      const response = await register({
        email,
        name,
        lastName,
        birthDate: birthDate ? birthDate : undefined, 
        gender,
        password,
        confirmPassword,
      });

      const token = response.data.token;
      if (token) {
        localStorage.setItem('token', token);
        navigate('/');
      }
    } catch (err) {
      setError('Ошибка регистрации, попробуйте еще раз.');
      console.error(err);
    }
  };

  // Функция для изменения пола (при нажатии на кнопку)
  const handleGenderSelect = (selectedGender: string) => {
    setGender(selectedGender);
  };

  return (
    <div className='login-wrapper'>
      <h1 className='login-title'>Регистрация</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <form className='login-form' onSubmit={handleSubmit}>
        {/* Почта */}
        <div>
          <input
            className='login-input'
            placeholder='Почта *'
            type='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {/* Имя */}
        <div>
          <input
            className='login-input'
            placeholder='Имя *'
            type='text'
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        {/* Фамилия */}
        <div>
          <input
            className='login-input'
            placeholder='Фамилия'
            type='text'
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>

        {/* Дата рождения */}
        <div>
          <input
            className='login-input'
            placeholder='Дата рождения'
            type='date'
            value={birthDate}
            onChange={(e) => setBirthDate(e.target.value)}
          />
        </div>

        {/* Пол — две кнопки */}
        <div className="gender-select-container">
          <button
            type="button"
            className={`gender-button male-button ${gender === 'male' ? 'selected' : ''}`}
            onClick={() => handleGenderSelect('male')}
          >
            Мужской
          </button>

          <button
            type="button"
            className={`gender-button female-button ${gender === 'female' ? 'selected' : ''}`}
            onClick={() => handleGenderSelect('female')}
          >
            Женский
          </button>
        </div>

        {/* Пароль */}
        <div>
          <input
            className='login-input'
            placeholder='Пароль *'
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {/* Подтверждение пароля */}
        <div>
          <input
            className='login-input'
            placeholder='Подтверждение пароля *'
            type='password'
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button className='login-btn' type='submit'>
          Создать аккаунт
        </button>
      </form>

      <p className='login-text'>
        Уже есть аккаунт? <a className='reg-link' href='/login'>Войти</a>
      </p>
    </div>
  );
};

export default RegisterPage;
